'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

export function ScrollToHash() {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  useEffect(() => {
    const hash = window.location.hash
    let timeoutId: ReturnType<typeof setTimeout> | undefined

    if (hash) {
      timeoutId = setTimeout(() => {
        const el = document.getElementById(hash.replace('#', ''))
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' })
        }
      }, 200)
    }

    return () => {
      if (timeoutId) clearTimeout(timeoutId)
    }
  }, [pathname, searchParams]) // Runs on navigation

  return null
}
